<template>
  <a-tabs type="card" v-model:activeKey="activeKey" @change="handleTabsUpdate">
    <a-tab-pane key="summaryOfpassRate" tab="合格率汇总">
      <pass-rate></pass-rate>
    </a-tab-pane>
    <a-tab-pane key="summaryOfunqualified" tab="不合格率汇总">
      <unqualified-statistics class="tab-pande-layout"></unqualified-statistics>
    </a-tab-pane>
    <a-tab-pane key="summaryOfunqualifiedDetails" tab="不合格问题明细">
      <unqualified-details class="tab-pande-layout"></unqualified-details>
    </a-tab-pane>

    <a-tab-pane key="feedbackType" tab="意见反馈">
      <feedback-vue :feedbackType="props.feedbackType"></feedback-vue>
    </a-tab-pane>

    <a-tab-pane key="abnormalIssues" tab="异常问题" v-if="props.feedbackType === '日常生产'">
      <product-problem ref="abnormalIssuesRef" type="abnormalIssues"></product-problem>
    </a-tab-pane>

    <a-tab-pane key="workingInstruction" tab="作业指导书" v-if="props.feedbackType === '日常生产'">
      <product-problem ref="workingInstructionRef" type="workingInstruction"></product-problem>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import { defineComponent, nextTick, provide, ref } from "vue";
import unqualifiedStatistics from "@/views/productDaily/components/quality/unqualified/index.vue";
import unqualifiedDetails from "@/views/productDaily/components/quality/unqualified/details.vue";
import passRate from "@/views/productDaily/components/quality/PassRate/index.vue";
import feedbackVue from "@/views/productDaily/components/feedback/index.vue";
import productProblem from '@/views/productDaily/pc/info/productProblem.vue';

export default defineComponent({
  props: {
    feedbackType: String,
  },
  components: {
    passRate,
    unqualifiedDetails,
    unqualifiedStatistics,
    feedbackVue,
    productProblem,
  },
  setup(props) {
    const activeKey = ref("summaryOfpassRate");

    provide("tabActivekey", activeKey);
    provide("subUnqualifiedKey", activeKey);

    const abnormalIssuesRef = ref();
    const workingInstructionRef = ref();

    const handleTabsUpdate = (activeKey) => {
      nextTick(() => {
        if (activeKey === 'abnormalIssues') {
          abnormalIssuesRef.value.init();
        } else if (activeKey === 'workingInstruction') {
          workingInstructionRef.value.init();
        }
      })
    };

    return {
      props,
      activeKey,
      handleTabsUpdate,
      abnormalIssuesRef,
      workingInstructionRef
    };
  },
});
</script>

<style lang="less" scoped>
.tab-pande-layout {
  height: calc(100vh - 200px);
}
</style>
